import { Link } from 'react-router-dom';
import React from 'react';

function Home() {
  return (
    <div
      className="bg-home-wrapper"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-start.svg'})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom left',
        minHeight: '100vh',
        width: '100%', 
      }}
    >
      <main className="container" role="main">
        <h1 className="section-title">Meine Lernfelder</h1>

      


     
          <div className="grid">

            <Link to="/notation" className="maincard card1" aria-label="Grafische Notation lesen und schreiben">
              <div className="card__header">
                <img src={process.env.PUBLIC_URL + '/img/icon-notation.png'} alt="Grafische Notation lesen und schreiben" />
              </div>
              <div className="card__body">
                <h2 className="card__title">Töne</h2>
                <p className="card__desc">Hier lernst du etwas über Töne!</p>
              </div>
            </Link>

            <Link to="/formen" className="maincard card3" aria-label="Musikalische Formen benennen">
              <div className="card__header">
                <img src={process.env.PUBLIC_URL + '/img/icon-musikalische-formen.png'} alt="Musikalische Formen benennen" />
              </div>
              <div className="card__body">
                <h2 className="card__title">Melodien</h2>
                <p className="card__desc">Hier lernst du etwas über Melodien!</p>
              </div>
            </Link>

            <Link to="/gestaltungsprinzipien" className="maincard card4" aria-label="Musikalische Gestaltungsprinzipien beschreiben">
              <div className="card__header">
                <img src={process.env.PUBLIC_URL + '/img/icon-gestaltungsprinzipien.png'} alt="" />
              </div>
              <div className="card__body">
                <h2 className="card__title">Rhythmus</h2>
                <p className="card__desc">Hier lernst du etwas über Rhythmus!</p>
              </div>
            </Link>

            <Link to="/instrumente" className="maincard card2" aria-label="Instrumente benennen">
              <div className="card__header">
                <img src={process.env.PUBLIC_URL + '/img/icon-instrumente.png'} alt="Instrumente benennen" />
              </div>
              <div className="card__body">
                <h2 className="card__title">Instrumente</h2>
                <p className="card__desc">Lerne die Instrumente kennen!</p>
              </div>
            </Link>
          </div> 
            </main>
        </div>
 
  );
}

export default Home;